import getAuthorizedLpsEpic from "./getAuthorizedLpsEpic";
import getLpSelectedEpic from "./getLpSelectedEpic";
import getAuthorizedEntitiesEpic from "./getAuthhorizedEntitiesEpic";
export var lpEpics = [
    getAuthorizedLpsEpic,
    getAuthorizedEntitiesEpic,
    getLpSelectedEpic
];
export default lpEpics;

//# sourceMappingURL=index.js.map